(() => {
  const initEquoProduct = (productRoot) => {
    if (!productRoot || productRoot.dataset.equoInitialized === 'true') {
      return;
    }

    productRoot.dataset.equoInitialized = 'true';

    /* ======================================================
       PRODUCT VARIANTS
       ====================================================== */

    const variantsScript = productRoot.querySelector('[data-equo-variants]');

    if (variantsScript) {
      let variants = [];

      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        console.error('Équo: Variantendaten konnten nicht geladen werden.', error);
      }

      const form = productRoot.querySelector(
        'form[data-type="add-to-cart-form"]'
      );

      const variantIdInput = form?.querySelector('input[name="id"]');

      const priceElement =
        productRoot.querySelector('[data-equo-price]');

      const comparePriceElement =
        productRoot.querySelector('[data-equo-compare-price]');

      const availabilityText =
        productRoot.querySelector('[data-equo-availability-text]');

      const availabilityDot =
        productRoot.querySelector('[data-equo-availability-dot]');

      const addButton =
        productRoot.querySelector('[data-equo-add]');

      const addButtonText =
        productRoot.querySelector('[data-equo-add-text]');

      const optionInputs =
        productRoot.querySelectorAll('input[data-equo-option]');

      const quantityInput =
        productRoot.querySelector('input[name="quantity"]');

      const minusButton =
        productRoot.querySelector('[data-equo-quantity-minus]');

      const plusButton =
        productRoot.querySelector('[data-equo-quantity-plus]');

      const mainImage =
        productRoot.querySelector('[data-equo-main-image]');

      const thumbnails =
        productRoot.querySelectorAll('[data-equo-thumbnail]');


      const currency =
        window.Shopify?.currency?.active || 'EUR';


      const formatMoney = (cents) => {
        return new Intl.NumberFormat('de-DE', {
          style: 'currency',
          currency
        }).format(cents / 100);
      };


      const getSelectedOptions = () => {
        const groups = {};

        optionInputs.forEach((input) => {
          if (input.checked) {
            groups[Number(input.dataset.optionPosition)] = input.value;
          }
        });

        return Object.keys(groups)
          .sort((a, b) => Number(a) - Number(b))
          .map((key) => groups[key]);
      };


      const findVariant = () => {
        const selectedOptions = getSelectedOptions();

        return variants.find((variant) => {
          if (!variant.options) return false;

          return variant.options.every(
            (option, index) => option === selectedOptions[index]
          );
        });
      };


      const updateProduct = () => {
        const variant = findVariant();

        if (!variant) {
          if (addButton) addButton.disabled = true;

          if (addButtonText) {
            addButtonText.textContent = 'Variante nicht verfügbar';
          }

          return;
        }


        if (variantIdInput) {
          variantIdInput.value = variant.id;

          variantIdInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        }


        if (priceElement) {
          priceElement.textContent = formatMoney(variant.price);
        }


        if (comparePriceElement) {
          if (
            variant.compare_at_price &&
            variant.compare_at_price > variant.price
          ) {
            comparePriceElement.textContent =
              formatMoney(variant.compare_at_price);

            comparePriceElement.hidden = false;
          } else {
            comparePriceElement.hidden = true;
          }
        }


        if (variant.available) {
          if (availabilityText) {
            availabilityText.textContent = 'Auf Lager';
          }

          if (availabilityDot) {
            availabilityDot.classList.remove(
              'equo-availability__dot--off'
            );
          }

          if (addButton) addButton.disabled = false;

          if (addButtonText) {
            addButtonText.textContent = 'In den Warenkorb';
          }
        } else {
          if (availabilityText) {
            availabilityText.textContent =
              'Derzeit nicht verfügbar';
          }

          if (availabilityDot) {
            availabilityDot.classList.add(
              'equo-availability__dot--off'
            );
          }

          if (addButton) addButton.disabled = true;

          if (addButtonText) {
            addButtonText.textContent = 'Ausverkauft';
          }
        }


        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);

        window.history.replaceState(
          {},
          '',
          url.toString()
        );
      };


      optionInputs.forEach((input) => {
        input.addEventListener('change', updateProduct);
      });


      if (minusButton && quantityInput) {
        minusButton.addEventListener('click', () => {
          const current =
            parseInt(quantityInput.value, 10) || 1;

          const min =
            parseInt(quantityInput.min, 10) || 1;

          quantityInput.value =
            Math.max(min, current - 1);

          quantityInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        });
      }


      if (plusButton && quantityInput) {
        plusButton.addEventListener('click', () => {
          const current =
            parseInt(quantityInput.value, 10) || 1;

          quantityInput.value = current + 1;

          quantityInput.dispatchEvent(
            new Event('change', { bubbles: true })
          );
        });
      }


      thumbnails.forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          const imageUrl = thumbnail.dataset.image;

          if (!imageUrl || !mainImage) return;

          /*
           * image_tag creates srcset.
           * Remove it when changing the primary image,
           * otherwise the browser may keep the old source.
           */
          mainImage.removeAttribute('srcset');
          mainImage.src = imageUrl;

          if (thumbnail.dataset.alt) {
            mainImage.alt = thumbnail.dataset.alt;
          }

          thumbnails.forEach((item) => {
            item.classList.remove('is-active');
          });

          thumbnail.classList.add('is-active');
        });
      });


      if (variants.length) {
        updateProduct();
      }
    }


    /* ======================================================
       DOSAGE CALCULATOR
       ====================================================== */

    const calculator =
      productRoot.querySelector('[data-equo-calculator]');

    const dosageScript =
      productRoot.querySelector('[data-equo-dosage-rules]');

    if (!calculator || !dosageScript) {
      return;
    }


    let dosageRules = [];

    try {
      dosageRules = JSON.parse(dosageScript.textContent);
    } catch (error) {
      console.error(
        'Équo: Dosierungsdaten konnten nicht geladen werden.',
        error
      );

      return;
    }


    dosageRules = dosageRules.filter((rule) => {
      return (
        rule.waterType &&
        rule.useCase &&
        Number(rule.referenceVolume) > 0 &&
        Number(rule.amount) >= 0
      );
    });


    if (!dosageRules.length) {
      return;
    }


    const waterTypeSelect =
      calculator.querySelector('[data-equo-water-type]');

    const useCaseSelect =
      calculator.querySelector('[data-equo-use-case]');

    const volumeInput =
      calculator.querySelector('[data-equo-volume]');

    const calculateButton =
      calculator.querySelector('[data-equo-calculate]');

    const errorElement =
      calculator.querySelector('[data-equo-calculator-error]');

    const result =
      calculator.querySelector('[data-equo-calculator-result]');

    const resultAmount =
      calculator.querySelector('[data-equo-result-amount]');

    const resultUnit =
      calculator.querySelector('[data-equo-result-unit]');

    const resultContent =
      calculator.querySelector('[data-equo-result-content]');

    const resultContentValue =
      calculator.querySelector('[data-equo-result-content-value]');

    const resultBasis =
      calculator.querySelector('[data-equo-result-basis]');

    const intervalWrap =
      calculator.querySelector('[data-equo-result-interval-wrap]');

    const intervalElement =
      calculator.querySelector('[data-equo-result-interval]');

    const noteWrap =
      calculator.querySelector('[data-equo-result-note-wrap]');

    const noteElement =
      calculator.querySelector('[data-equo-result-note]');


    const uniqueValues = (values) => {
      return [...new Set(values.filter(Boolean))];
    };


    const formatNumber = (number, maxDecimals = 2) => {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: maxDecimals
      }).format(number);
    };


    const clearResult = () => {
      if (result) result.hidden = true;
      if (errorElement) errorElement.hidden = true;
    };


    const showError = (message) => {
      if (result) result.hidden = true;

      if (errorElement) {
        errorElement.textContent = message;
        errorElement.hidden = false;
      }
    };


    /* ------------------------------------------------------
       Populate water types
       ------------------------------------------------------ */

    const waterTypes =
      uniqueValues(dosageRules.map((rule) => rule.waterType));

    waterTypes.forEach((waterType) => {
      const option = document.createElement('option');

      option.value = waterType;
      option.textContent = waterType;

      waterTypeSelect.appendChild(option);
    });


    /* ------------------------------------------------------
       Populate use cases based on water type
       ------------------------------------------------------ */

    const updateUseCases = () => {
      const selectedWaterType = waterTypeSelect.value;

      useCaseSelect.innerHTML = '';

      clearResult();


      if (!selectedWaterType) {
        const option = document.createElement('option');

        option.value = '';
        option.textContent = 'Zuerst Aquarientyp wählen';

        useCaseSelect.appendChild(option);
        useCaseSelect.disabled = true;

        return;
      }


      const useCases = uniqueValues(
        dosageRules
          .filter(
            (rule) => rule.waterType === selectedWaterType
          )
          .map((rule) => rule.useCase)
      );


      const placeholder =
        document.createElement('option');

      placeholder.value = '';
      placeholder.textContent = 'Bitte auswählen';

      useCaseSelect.appendChild(placeholder);


      useCases.forEach((useCase) => {
        const option = document.createElement('option');

        option.value = useCase;
        option.textContent = useCase;

        useCaseSelect.appendChild(option);
      });


      useCaseSelect.disabled = false;
    };


    waterTypeSelect.addEventListener(
      'change',
      updateUseCases
    );

    useCaseSelect.addEventListener(
      'change',
      clearResult
    );

    volumeInput.addEventListener(
      'input',
      clearResult
    );


    /* ------------------------------------------------------
       Calculation
       ------------------------------------------------------ */

    calculateButton.addEventListener('click', () => {
      clearResult();


      const waterType = waterTypeSelect.value;
      const useCase = useCaseSelect.value;
      const volume = Number(
        String(volumeInput.value).replace(',', '.')
      );


      if (!waterType) {
        showError('Bitte wähle zuerst den Aquarientyp.');
        return;
      }


      if (!useCase) {
        showError('Bitte wähle den Anwendungsfall.');
        return;
      }


      if (!Number.isFinite(volume) || volume <= 0) {
        showError(
          'Bitte gib ein gültiges Aquarienvolumen ein.'
        );

        return;
      }


      const rule = dosageRules.find((item) => {
        return (
          item.waterType === waterType &&
          item.useCase === useCase
        );
      });


      if (!rule) {
        showError(
          'Für diese Auswahl ist keine Dosierungsregel hinterlegt.'
        );

        return;
      }


      const referenceVolume =
        Number(rule.referenceVolume);

      const baseAmount =
        Number(rule.amount);


      if (
        !Number.isFinite(referenceVolume) ||
        referenceVolume <= 0 ||
        !Number.isFinite(baseAmount)
      ) {
        showError(
          'Die hinterlegte Dosierungsregel ist unvollständig.'
        );

        return;
      }


      /*
       * Linear scaling:
       * dosage = aquarium volume / reference volume × amount
       */
      const calculatedAmount =
        (volume / referenceVolume) * baseAmount;


      if (resultAmount) {
        resultAmount.textContent =
          formatNumber(calculatedAmount);
      }


      if (resultUnit) {
        resultUnit.textContent =
          rule.doseUnit || '';
      }


      /*
       * Optional total content:
       * Example:
       * 14 ampoules × 5 ml = 70 ml
       */
      const contentPerUnit =
        Number(rule.contentPerUnit);


      if (
        Number.isFinite(contentPerUnit) &&
        contentPerUnit > 0 &&
        rule.contentUnit
      ) {
        const totalContent =
          calculatedAmount * contentPerUnit;

        if (resultContentValue) {
          resultContentValue.textContent =
            `${formatNumber(totalContent)} ${rule.contentUnit}`;
        }

        if (resultContent) {
          resultContent.hidden = false;
        }
      } else if (resultContent) {
        resultContent.hidden = true;
      }


      /*
       * Show the original rule as calculation basis.
       * We do NOT invent or modify the manufacturer's rule.
       */
      if (resultBasis) {
        resultBasis.textContent =
          `Berechnungsgrundlage: ${formatNumber(baseAmount)} ` +
          `${rule.doseUnit || ''} je ` +
          `${formatNumber(referenceVolume)} ` +
          `${rule.volumeUnit || 'Liter'}.`;
      }


      if (rule.interval) {
        if (intervalElement) {
          intervalElement.textContent = rule.interval;
        }

        if (intervalWrap) {
          intervalWrap.hidden = false;
        }
      } else if (intervalWrap) {
        intervalWrap.hidden = true;
      }


      if (rule.dosageText) {
        if (noteElement) {
          noteElement.textContent = rule.dosageText;
        }

        if (noteWrap) {
          noteWrap.hidden = false;
        }
      } else if (noteWrap) {
        noteWrap.hidden = true;
      }


      if (errorElement) {
        errorElement.hidden = true;
      }

      if (result) {
        result.hidden = false;
      }
    });
  };


  /* ========================================================
     INITIAL PAGE LOAD
     ======================================================== */

  const initAllEquoProducts = (scope = document) => {
    scope
      .querySelectorAll('[data-equo-product]')
      .forEach(initEquoProduct);
  };


  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      () => initAllEquoProducts()
    );
  } else {
    initAllEquoProducts();
  }


  /* ========================================================
     SHOPIFY THEME EDITOR
     ======================================================== */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initAllEquoProducts(event.target);
    }
  );
})();